import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material'
import DisplayPrice from 'components/Common/DisplayValues/DisplayPrice'
import VehicleDisplayName from 'components/Common/VehicleDisplayName/VehicleDisplayName'
import React from 'react'
import { confirmAlert } from 'react-confirm-alert'

type CancelBookingProps = {
  bookingReference: string
  action: any
  bookingJobs: any
  booking?: any
}

const handleCancelBooking = async ({
  action,
  bookingReference,
  bookingJobs,
  booking,
}: CancelBookingProps) => {
  const singleVehicleMessage = (
    <DialogContent sx={{ marginTop: '20px' }}>
      <Typography>
        Please confirm that you still want to cancel <b>{bookingReference}</b>
      </Typography>
      <Grid>
        <ListItem alignItems="center">
          <Box
            component="img"
            src={bookingJobs[0].vehicleDetails.icon}
            sx={{ width: '25%' }}
          />
          <ListItemText
            sx={{ marginLeft: '10px', width: '25%' }}
            primary={VehicleDisplayName({
              vehicleDetails: bookingJobs[0].vehicleDetails,
            })}
            secondary={
              <React.Fragment>
                {bookingJobs[0].jobReference}
                {DisplayPrice({
                  VATTotalPrice: bookingJobs[0].estimatedPrice,
                  displayVATPrice: booking.client.displayVAT,
                })}
              </React.Fragment>
            }
          />
          <ListItemText
            sx={{ marginLeft: '70px' }}
            primary={`Cancellation Policy`}
            secondary={
              <Box
                sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
              >
                <Typography
                  sx={{ display: 'inline', textWrap: 'balance' }}
                  component="span"
                  variant="body2"
                  color="text.primary"
                >
                  {bookingJobs[0].cancellationPolicy}
                </Typography>

                {booking.policy.cancellation.fee && (
                  <Typography variant="body2" color="text.primary">
                    Estimated Cancellation Charge:{' '}
                    {DisplayPrice({
                      VATTotalPrice: booking.policy.cancellation.fee ?? 0,
                      displayVATPrice: booking.client.displayVAT,
                    })}
                  </Typography>
                )}
              </Box>
            }
          />
        </ListItem>
      </Grid>
    </DialogContent>
  )

  const multiVehicleMessageDetail = bookingJobs.map(
    (job: any, index: number) => (
      <Grid key={index} sx={{ display: 'flex', alignItems: 'center' }}>
        <ListItem>
          <Box
            component="img"
            src={job.vehicleDetails.icon}
            sx={{ width: '15%' }}
          />
          <ListItemText
            sx={{ marginLeft: '30px' }}
            primary={VehicleDisplayName({
              vehicleDetails: job.vehicleDetails,
            })}
            secondary={
              <React.Fragment>
                {job.jobReference}
                {DisplayPrice({
                  VATTotalPrice: job.estimatedPrice,
                  displayVATPrice: booking.client.displayVAT,
                })}
              </React.Fragment>
            }
          />
          <ListItemText
            sx={{ marginLeft: '70px' }}
            primary={`Cancellation Policy`}
            secondary={
              <React.Fragment>
                <Typography
                  sx={{ display: 'inline' }}
                  component="span"
                  variant="body2"
                  color="text.primary"
                >
                  {job.cancellationPolicy}
                </Typography>
              </React.Fragment>
            }
          />
        </ListItem>
      </Grid>
    ),
  )

  const multiVehicleMessage = (
    <DialogContent
      sx={{ display: 'flex', marginTop: '20px', flexDirection: 'column' }}
    >
      <p>
        <Typography>
          There are {bookingJobs.length} vehicles in <b>{bookingReference}</b>
        </Typography>
      </p>
      {multiVehicleMessageDetail}
      <p>
        <Typography>
          Please confirm that you still want to cancel <b>{bookingReference}</b>
        </Typography>
      </p>
    </DialogContent>
  )
  console.log('cancel bookingJobs: ', bookingJobs)
  if (bookingJobs.length > 1) {
    console.log(multiVehicleMessage)
  }
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <Dialog
          open={true}
          onClose={onClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle
            id="alert-dialog-title"
            sx={(theme) => ({
              backgroundColor: '#ee000e',
              color: theme.palette.info.contrastText,
              fontSize: 'var(--fs-24, 1.5rem)',
            })}
          >
            Cancellation Confirmation
          </DialogTitle>
          {bookingJobs.length > 1 ? multiVehicleMessage : singleVehicleMessage}
          <DialogActions>
            <Button onClick={onClose}>No</Button>
            <Button
              color="primary"
              onClick={() => {
                action()
                onClose()
              }}
            >
              Yes, Cancel it!
            </Button>
          </DialogActions>
        </Dialog>
      )
    },
  })
}

export default handleCancelBooking
